import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { PLANS, planToParams } from "@/data/content";

export default function Plans() {
  const navigate = useNavigate();

  return (
    <section id="plans" className="bg-[#F5F7FC] border-y border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-6 py-24">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#3B82F6]">One-time services</p>
          <h2 className="font-display text-3xl sm:text-4xl tracking-tight mt-3 uppercase">Consultancy &amp; development</h2>
          <p className="text-[#475569] mt-5">Pick a one-time service — radio consultancy, project setup, software consultation, or a custom amount. No subscription, and every service includes a 15-day free-fix guarantee.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-14 items-stretch">
          {PLANS.map((plan, i) => (
            <motion.div
              key={plan.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className={`relative rounded-2xl p-8 flex flex-col transition-all duration-300 ${
                plan.featured ? "bg-[#26395F] text-white shadow-2xl lg:scale-[1.04]" : "bg-white text-[#0F172A] border border-[#E2E8F0] hover:border-[#3B82F6] hover:shadow-lg"
              }`}
              data-testid={`plan-card-${plan.id}`}
            >
              <div className="flex items-center justify-between">
                <span className={`text-xs font-semibold uppercase tracking-[0.15em] ${plan.featured ? "text-white/60" : "text-[#475569]"}`}>{plan.name}</span>
                {plan.badge && (
                  <span className={`text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full ${plan.featured ? "bg-[#3B82F6] text-[#0F172A]" : "bg-[#3B82F6]/10 text-[#3B82F6]"}`}>{plan.badge}</span>
                )}
              </div>

              <div className="mt-6 flex items-end gap-2">
                {plan.custom ? (
                  <span className="font-display text-4xl tracking-tight">Custom</span>
                ) : (
                  <>
                    <span className="font-display text-5xl tracking-tight">${plan.price}</span>
                    <span className="mb-2 text-sm font-semibold text-[#3B82F6]">one-time</span>
                  </>
                )}
              </div>
              <p className={`text-xs mt-2 ${plan.featured ? "text-white/60" : "text-[#475569]"}`}>{plan.unit}</p>

              <ul className="mt-7 space-y-3 flex-1">
                {plan.perks.map((perk) => (
                  <li key={perk} className={`flex items-start gap-3 text-sm ${plan.featured ? "text-white/85" : "text-[#334155]"}`}>
                    <Check className="h-4 w-4 text-[#3B82F6] shrink-0 mt-0.5" />
                    <span>{perk}</span>
                  </li>
                ))}
              </ul>

              <button
                onClick={() => navigate(`/checkout${planToParams(plan)}`)}
                className={`btn-sweep mt-8 w-full font-bold py-3.5 rounded-full transition-all duration-300 ${
                  plan.featured ? "bg-[#3B82F6] text-[#0F172A] hover:glow-primary" : "bg-[#26395F] text-white hover:bg-[#3B82F6] hover:text-[#0F172A]"
                }`}
                data-testid={`plan-select-${plan.id}`}
              >
                {plan.cta}
              </button>
            </motion.div>
          ))}
        </div>

        <p className="text-xs text-[#94A3B8] mt-10 max-w-4xl leading-relaxed">
          <span className="font-bold text-[#475569]">SERVICE DETAILS:</span> All charges are <span className="font-semibold">one-time</span> for the service you select.
          We do <span className="font-semibold">not</span> offer subscriptions and will never auto-renew or bill you again. If you experience any issue after
          delivery, we provide a <span className="font-semibold">15-day guarantee</span> during which we will fix it free of charge. Radio App Consultancy is an
          independent consultancy and is not affiliated with, endorsed by, or sponsored by any brand. All product names, logos, and trademarks are the
          property of their respective owners.
        </p>
      </div>
    </section>
  );
}
